import React, { Component } from 'react';
import { Container, Icon, Menu, Sidebar } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import MainMenu, { SettingsConsumer } from '@devgateway/wp-react-lib';
import { Media } from "./AppMedia";
import Footer from "./Footer";
import Header from "./Header";
import TopNavigator from "./TopNavigator";
import CustomizerWrapper from "./Customizer";
class DesktopContainer extends Component {
  render() {
    const {
      children,
      fixed
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, {
      fluid: true
    }, /*#__PURE__*/React.createElement(SettingsConsumer, null, /*#__PURE__*/React.createElement(CustomizerWrapper, {
      key: "header"
    }, /*#__PURE__*/React.createElement(Header, null))), /*#__PURE__*/React.createElement(Container, {
      className: "desktop"
    }, children), /*#__PURE__*/React.createElement(SettingsConsumer, null, /*#__PURE__*/React.createElement(TopNavigator, {
      key: "header"
    })));
  }
}
DesktopContainer.propTypes = {
  children: PropTypes.node
};
class MobileContainer extends Component {
  state = {};
  handleSidebarHide = () => this.setState({
    sidebarOpened: false
  });
  handleToggle = () => this.setState({
    sidebarOpened: true
  });
  render() {
    const {
      children,
      big
    } = this.props;
    const {
      sidebarOpened
    } = this.state;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Sidebar, {
      as: Menu,
      animation: "push",
      onHide: this.handleSidebarHide,
      vertical: true,
      visible: sidebarOpened
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(MainMenu, {
      slug: "main"
    }))), /*#__PURE__*/React.createElement(Sidebar.Pusher, {
      dimmed: sidebarOpened
    }, /*#__PURE__*/React.createElement(Container, {
      fluid: true
    }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(Menu.Item, {
      onClick: this.handleToggle
    }, " ", /*#__PURE__*/React.createElement(Icon, {
      name: "sidebar",
      color: "orange"
    }), " ")), children)));
  }
}
MobileContainer.propTypes = {
  children: PropTypes.node
};
class ResponsiveContainer extends Component {
  render() {
    const {
      children,
      fixed
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("style", null, Media.mediaStyles), /*#__PURE__*/React.createElement(DesktopContainer, {
      fixed: fixed
    }, children), /*#__PURE__*/React.createElement(Footer, null));
  }
}
export default ResponsiveContainer;